import BaseService from "./base.service";
import http from "../http-common";
class PermissionService extends BaseService {
  constructor() {
    super("permissions");
  }
  getById(id) {
    return http.get(`${this.path}/listById/${id}`);
  }

  duplicate(id) {
    return http.post(`${this.path}/duplicate/${id}`);
  }
}

export default new PermissionService();
